window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start();

require('./components/tracking.js');
require('./components/search.js');
require('./components/tooltip.js');
require('./components/lightbox.js');
require('./components/modal.js');
require('./components/links.js');
require('./components/destroy.js');
require('./components/uploader.js');
require('./components/autosize.js');
require('./components/accordion.js');
require('./components/swiper.js');
